import { useAxios } from '@app/utils/useAxios'
import { BackofficeApiEventResponse } from '@lib/Core/API/BackofficeApiEventResponse'
import { BackofficeApiEventSchema } from '@lib/Core/API/BackofficeApiEventSchema'
import { BackofficeAPIConfig } from '@lib/Core/API/BackofficeAPIConfig'
import { BackofficeApiActions } from '@lib/Core/API/BackofficeApiActions'
import { CodeBlock, CodeBlockCode, Spinner } from '@patternfly/react-core'
import { AxiosResponse } from 'axios'
import * as React from 'react'
import { IGenericComponentInModalProps } from '@app/components/modal/IGenericComponentInModalProps'
import { getErrorMessage } from '@lib/Error/getErrorMessage'

interface ILineItem {
  line_item_id: string
  title: string
  sku: string
  quantity: number
  price: number
  is_fulfilled: boolean
  customer_id: string
  cream_assignment_id: string
  customer_order_id: string
  created_at: Date
  updated_at: Date
  fulfilled_at: null
  properties: null
}

const component: React.FunctionComponent<IGenericComponentInModalProps> = (props: IGenericComponentInModalProps) => {
  const api = useAxios()
  const [lineItem, setLineItem] = React.useState<ILineItem>()
  const [loading, setLoading] = React.useState(true)

  const lineItemId = props.data.lineItemId

  React.useEffect(() => {
    const abortController = new AbortController()

    const payload: BackofficeApiEventSchema = {
      action: BackofficeApiActions.GetLineItem,
      data: { lineItemId },
    }

    api.current
      ?.post(BackofficeAPIConfig.Domains.Customer, payload)
      .then((response: AxiosResponse<BackofficeApiEventResponse>) => {
        const lineItem = response?.data.result as ILineItem
        setLineItem(lineItem)
        setLoading(false)
      })
      .catch((error) => {
        alert(getErrorMessage(error))
        setLoading(false)
      })

    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <React.Fragment>
      {loading && <Spinner />}
      {!loading && (
        <CodeBlock>
          <CodeBlockCode id="code-content">{JSON.stringify(lineItem, null, 2)}</CodeBlockCode>
        </CodeBlock>
      )}
    </React.Fragment>
  )
}

const CustomerLineItem = React.memo(component)

export { CustomerLineItem }
